// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modal-add-task #editable-div{height:70px}.width50px{min-width:50px;max-width:50px}", ""]);
// Exports
module.exports = exports;
